import { render, staticRenderFns } from "./DonationBlock.vue?vue&type=template&id=71f92911&"
import script from "./DonationBlock.vue?vue&type=script&lang=js&"
export * from "./DonationBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports